module.exports = __webpack_public_path__ + "img/pr-2.cbf62a1e.png";